import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
})
export class ChartComponent {
  @Input() public title: string;
  @Input() public tooltip: string;
  @Input() public headerExtraContent: TemplateRef<unknown>;
}
